import { Badge } from '@mantine/core';
import { IconFlag } from '@tabler/icons-react';

interface PriorityBadgeProps {
  label: string;
  color: string;
}

const PriorityBadge = ({ label, color }: PriorityBadgeProps) => {
  return (
    <Badge
      variant="outline"
      color={color}
      size="lg"
      radius="md"
      leftSection={<IconFlag size={14} color={color} />}
      styles={{
        root: {
          textTransform: 'none',
          color: 'black',
          fontWeight: 400,
        },
      }}
    >
      {label}
    </Badge>
  );
};

export default PriorityBadge;
